<template>
  <div class="branch-scale-comparison">
    <a-card
        :bordered="true"
        class="branch-scale-comparison__card pdf-avoid-break"
    >
      <a-tag class="branch-scale-comparison__tag">
        {{ previousLabel }}
      </a-tag>

      <div class="branch-scale-comparison__header">
        <h3 class="branch-scale-comparison__title">
          {{ title }}
        </h3>

        <QuestionCircleOutlined class="branch-scale-comparison__help-icon" />
      </div>

      <EiScaleRowsTable
          :sections="previousSections"
          :show-scale-after-each-section="false"
          :show-difference="true"
          :row-gap="12"
          :scale-height="8"
          :hide-zero-difference="true"
      />
    </a-card>

    <a-card
        :bordered="true"
        class="branch-scale-comparison__card pdf-avoid-break"
    >
      <a-tag class="branch-scale-comparison__tag branch-scale-comparison__tag--current">
        {{ currentLabel }}
      </a-tag>

      <div class="branch-scale-comparison__header">
        <h3 class="branch-scale-comparison__title">
          {{ title }}
        </h3>

        <QuestionCircleOutlined class="branch-scale-comparison__help-icon" />
      </div>

      <EiScaleRowsTable
          :sections="currentSections"
          :show-scale-after-each-section="false"
          :show-difference="true"
          :row-gap="12"
          :scale-height="8"
          :hide-zero-difference="true"
      />
    </a-card>
  </div>
</template>

<script>
import { QuestionCircleOutlined } from '@ant-design/icons-vue'

import EiScaleRowsTable from '@/components/Analytics/EiScaleRowsTable.vue'

export default {
  name: 'BranchScaleComparisonBlock',

  components: {
    QuestionCircleOutlined,
    EiScaleRowsTable,
  },

  props: {
    previousLabel: {
      type: String,
      default: 'Было',
    },

    currentLabel: {
      type: String,
      default: 'Стало',
    },

    title: {
      type: String,
      default: '',
    },

    previousSections: {
      type: Array,
      default: () => [],
    },

    currentSections: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped lang="scss">
.branch-scale-comparison {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.branch-scale-comparison__card {
  position: relative;
  min-width: 0;
  border-radius: 8px;
}

.branch-scale-comparison__card :deep(.ant-card-body) {
  padding: 18px 16px 14px;
}

.branch-scale-comparison__tag {
  position: absolute;
  top: -10px;
  left: 20px;
  z-index: 2;
  margin: 0;
  height: 20px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  font-size: 12px;
  line-height: 18px;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.65);
  border-color: #d5dbe2;
}

.branch-scale-comparison__tag--current {
  color: var(--geek-blue);
  border-color: var(--geek-blue-3);
  background-color: var(--geek-blue-1);
}

.branch-scale-comparison__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.branch-scale-comparison__title {
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.88);
}

.branch-scale-comparison__help-icon {
  flex: 0 0 auto;
  margin-top: 2px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
}

.branch-scale-comparison :deep(.ei-scale-table__rows-guides) {
  top: 22px;
  bottom: 18px;
}

.branch-scale-comparison :deep(.ei-scale-table__row-header) {
  margin-bottom: 6px;
}

.branch-scale-comparison :deep(.ei-scale-table__value) {
  min-width: 34px;
}

.branch-scale-comparison :deep(.ei-scale-table__bottom-scale) {
  margin-top: 6px;
}

@media (max-width: $tablet-breakpoint) {
  .branch-scale-comparison {
    grid-template-columns: 1fr;
  }
}

@media (max-width: $mobile-breakpoint) {
  .branch-scale-comparison__card :deep(.ant-card-body) {
    padding: 18px 12px 14px;
  }
}
</style>